// Set admin flag if we're in WordPress admin
window.isAdmin = typeof wp !== 'undefined' && wp.hasOwnProperty('blocks')

/**
 * Module Registry System
 *
 * This system allows for easy registration and loading of modules based on DOM selectors.
 * Each module is only loaded when its selector is found on the page.
 */
export class ModuleManager {
  constructor() {
    this.modules = []
    this.adminModules = {}
  }

  /**
   * Register a frontend module that will load when its selector is found
   * @param {string} selector - CSS selector or ID to check for
   * @param {string} modulePath - Path to the module file
   * @param {boolean} alwaysLoad - Whether to load the module regardless of selector
   */
  register(selector, modulePath, alwaysLoad = false) {
    this.modules.push({ selector, modulePath, alwaysLoad })
    return this
  }

  /**
   * Register a module that can be manually initialized in admin
   * @param {string} name - Name of the module
   * @param {string} modulePath - Path to the module file
   */
  registerAdmin(name, modulePath) {
    this.adminModules[name] = modulePath
    return this
  }

  /**
   * Initialize all registered modules whose selectors exist on the page
   */
  init() {
    // Initialize frontend modules
    this.modules.forEach(({ selector, modulePath, alwaysLoad }) => {
      const shouldLoad =
        alwaysLoad ||
        (selector.startsWith('#')
          ? document.getElementById(selector.substring(1))
          : document.querySelector(selector))

      if (shouldLoad && (!window.isAdmin || alwaysLoad)) {
        this.loadModule(modulePath)
      }
    })

    // Make admin modules available globally
    window.appModules = {}
    Object.entries(this.adminModules).forEach(([name, modulePath]) => {
      window.appModules[`init${name}`] = () => this.loadModule(modulePath)
    })
  }

  /**
   * Load a module by its path
   * @param {string} modulePath - Path to the module
   * @param {ParentNode} root - Where the module looks for its elements
   */
  loadModule(modulePath, root = document) {
    import(`./modules/${modulePath}.js`)
      .then((module) => {
        if (typeof module.default === 'function') {
          module.default(root)
        }
      })
      .catch((err) => console.error(`Failed to load module: ${modulePath}`, err))
  }
}